"use client"

import { Share2 } from "lucide-react"
import { useCallback } from "react"

interface ShareButtonProps {
  title: string
  url: string
}

export function ShareButton({ title, url }: ShareButtonProps) {

  const handleShare = useCallback(async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url })
      } catch (err) {
        console.error("Erro ao compartilhar:", err)
      }
    } else {
      // fallback: copia o link para a área de transferência
      try {
        await navigator.clipboard.writeText(url)
      
      } catch (err) {
        console.error("Erro ao copiar o link:", err)
      }
    }
  }, [title, url])

  return (
    <button
      onClick={handleShare}
      className="p-2 border border-border hover:bg-black/10 transition-colors duration-200 cursor-pointer rounded-lg"
      aria-label="Compartilhar post"
      type="button"
    >
      <Share2 size={16} />
    </button>
  )
}
